const Networks = [
  {
    headquarters: 'Los Gatos, California',
    homepage: 'http://www.netflix.com',
    id: 213,
    logo_path: '/wwemzKWzjKYJFfCeiB57q3r4Bcm.png',
    name: 'Netflix',
    origin_country: '',
    sub: true,
  },
  {
    headquarters: 'New York City, New York',
    homepage: 'https://www.hbomax.com',
    id: 3186,
    logo_path: '/nmU0UMDJB3dRRQSTUqawzF2Od1a.png',
    name: 'HBO Max',
    origin_country: 'US',
    sub: false,
  },
  {
    headquarters: 'Los Angeles, California',
    homepage: 'http://www.hallmarkchannel.com',
    id: 384,
    logo_path: '/9JTL7HcaiVxq7M6eu5m7giFqaxR.png',
    name: 'Hallmark Channel',
    origin_country: 'US',
    sub: false,
  },
  {
    headquarters: 'New York City, New York',
    homepage: 'http://www.nbc.com',
    id: 6,
    logo_path: '/nGRVQlfmPBmfkNgCFpx5m7luTxG.png',
    name: 'NBC',
    origin_country: 'US',
    sub: false,
  },
  {
    headquarters: 'New York City, New York ',
    homepage: 'https://www.nick.com',
    id: 13,
    logo_path: '/ikZXxg6GnwpzqiZbRPhJGaZapqB.png',
    name: 'Nickelodeon',
    origin_country: 'US',
    sub: false,
  },
  {
    headquarters: 'Los Angeles, California',
    homepage: 'https://www.fox.com',
    id: 19,
    logo_path: '/1DSpHrWyOORkL9N2QHX7Adt31mQ.png',
    name: 'FOX',
    origin_country: 'US',
    sub: true,
  },
  {
    headquarters: 'New York City, New York',
    homepage: 'https://www.bet.com',
    id: 24,
    logo_path: '/gaouRlJrfZlEA5EPHhO5qqZ1Fgu.png',
    name: 'BET',
    origin_country: 'US',
    sub: false,
  },
  {
    headquarters: 'Bristol, Connecticut',
    homepage: 'https://www.espn.com',
    id: 29,
    logo_path: '/w9le4FUeXVlKLfnlkuk1djRrena.png',
    name: 'ESPN',
    origin_country: 'US',
    sub: false,
  },
  {
    headquarters: 'New York City, New York',
    homepage: 'http://www.usanetwork.com',
    id: 30,
    logo_path: '/g1e0H0Ka97IG5SyInMXdJkHGKiH.png',
    name: 'USA Network',
    origin_country: 'US',
    sub: false,
  },
  {
    headquarters: 'New York City, New York',
    homepage: 'http://www.mtv.com',
    id: 33,
    logo_path: '/w4qtv7xBkSVsbOQdSzjUjlyOuSr.png',
    name: 'MTV',
    origin_country: 'US',
    sub: false,
  },
  {
    headquarters: 'Atlanta, Georgia',
    homepage: 'https://www.cartoonnetwork.com',
    id: 56,
    logo_path: '/c5OC6oVCg6QP4eqzW6XIq17CQjI.png',
    name: 'Cartoon Network',
    origin_country: 'US',
    sub: false,
  },
  {
    headquarters: 'Burbank, California',
    homepage: 'https://disneynow.com/all-shows/disney-xd',
    id: 44,
    logo_path: '/nKM9EnV7jTpt3MKRbhBusJ03lAY.png',
    name: 'Disney XD',
    origin_country: 'US',
    sub: false,
  },
  {
    headquarters: 'New York City, New York',
    homepage: 'http://www.cc.com',
    id: 47,
    logo_path: '/6ooPjtXufjsoskdJqj6pxuvHEno.png',
    name: 'Comedy Central',
    origin_country: 'US',
    sub: false,
  },
  {
    headquarters: 'New York City, New York',
    homepage: 'https://www.hbo.com',
    id: 49,
    logo_path: '/tuomPhY2UtuPTqqFnKMVHvSb724.png',
    name: 'HBO',
    origin_country: 'US',
    sub: true,
  },
  {
    headquarters: 'Toronto, Ontario',
    homepage: 'http://www.thecomedynetwork.ca',
    id: 51,
    logo_path: '/zWANL77d5GiGouIaL5o8a2hErRv.png',
    name: 'The Comedy Network',
    origin_country: 'CA',
    sub: false,
  },
  {
    headquarters: 'Burbank, California',
    homepage: 'https://disneynow.com/all-shows/disney-channel',
    id: 54,
    logo_path: '/bZmY2j50TwwSEnSBNPUWBfDL4SE.png',
    name: 'Disney Channel',
    origin_country: 'US',
    sub: false,
  },
  {
    headquarters: 'Washington, D.C.',
    homepage: 'http://channel.nationalgeographic.com/',
    id: 43,
    logo_path: '/q9rPBG1rHbUjII1Qn98VG2v7cFa.png',
    name: 'National Geographic',
    origin_country: 'US',
    sub: false,
  },
  {
    headquarters: 'Silver Spring, Maryland',
    homepage: 'https://www.discovery.com',
    id: 64,
    logo_path: '/8qkdZlbrTSVfkJ73DjOBrwYtMSC.png',
    name: 'Discovery',
    origin_country: 'US',
    sub: false,
  },
  {
    headquarters: 'New York City, New York',
    homepage: 'http://www.sho.com',
    id: 67,
    logo_path: '/Allse9kbjiP6ExaQrnSpIhkurEi.png',
    name: 'Showtime',
    origin_country: 'US',
    sub: false,
  },
  {
    headquarters: 'Atlanta, Georgia',
    homepage: 'http://www.adultswim.com',
    id: 80,
    logo_path: '/tHZPHOLc6iF27G34cAZGPsMtMSy.png',
    name: 'Adult Swim',
    origin_country: 'US',
    sub: false,
  },
];

export default Networks;
